import { isCallable } from '@afterpay/utils'
export type Runnable<R> = () => PromiseLike<R> | R

const limits: Map<string, Array<Runnable<any>>> = new Map()

export const limitOnce = async <R>(token: string, actionProducer: () => PromiseLike<R> | R): Promise<R> => {
  if (!limits.has(token)) {
    limits.set(token, [])
    try {
      return await actionProducer()
    } finally {
      setTimeout(async () => {
        const limit = limits.get(token)
        if (limit !== undefined) {
          while (limit.length > 0) {
            const task = limit.pop()
            isCallable(task) && (await task())
          }
        }

        limits.delete(token)
      })
    }
  } else {
    return await new Promise<R>((resolve, reject) => {
      limits.get(token)?.push(async (): Promise<void> => {
        await Promise.resolve(actionProducer()).then(resolve, reject)
      })
    })
  }
}

export const sleep = async (millis: number): Promise<number> => {
  return await new Promise((resolve) => setTimeout(() => resolve(millis), millis))
}
